import domReady from '@roots/sage/client/dom-ready';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * Dom ready
 */
domReady(() => {
  const block = document.querySelector('.partial-content-single');

  // eslint-disable-next-line no-unused-vars
  const swiper = new Swiper(block.querySelector('.swiper'), {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 600,
    pagination: {
      el: block.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: block.querySelector('.swiper-button-next'),
      prevEl: block.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });
});
